export default {
    closeAllConditions(search) {
        search.filters.enable = false;
        search.order.enable = false;
        search.limit.enable = false;
        search.excelExport.enable = false;
    },
    getSizeConfig() {
        return [5, 10, 20, 50, 100, 200, '所有'];
    },
    getSearchParams(opt = null) {
        let condition = {
            filters: {
                enable: false,
                conditions: []  
            },
            order: {
                enable: false,
                conditions: []
            },
            limit: {
                enable: true,
                conditions: {
                    pageLength: 10,
                    pageStart: 1,
                    total: 0
                }
            },
            excelExport: {
                enable: false,
                columns: []
            }
        };

        if (opt && opt.hasOwnProperty('closeAllConditions') && opt.closeAllConditions) {
            this.closeAllConditions(condition);
        }

        return condition;
    },
    globalPageOnChange(search, pageIndex) {
        search.limit.conditions.pageStart = pageIndex;
    },
    globalResetSearch(search) {
        search.limit.conditions.pageStart = 1;
    },
    globalSetFilterRecordCount(search, count) {
        search.limit.conditions.total = count;
    },
    globalAddFilterConditionKey(search, conditionName, op, value, custom = false) {
        this.globalRemoveFilterConditionKey(search, conditionName);
        search.filters.enable = true;
        search.filters.conditions.push({
            name: conditionName,
            type: op,
            value: value,
            custom: custom
        });
    },
    globalRemoveFilterConditionKey(search, conditionName) {
        let index = search.filters.conditions.findIndex(e => {
            return e.name === conditionName;
        });
        if (index !== -1) {
            search.filters.conditions.splice(index, 1);
        }
    },
    globalAddOrderConditionKey(search, conditionName, conditionType) {
        this.globalRemoveFilterConditionKey(search, conditionName);
        search.order.enable = true;
        search.order.condition.push({
            name: conditionName,
            type: conditionType
        });
    },
    globalRemoveOrderConditionKey(search, conditionName) {
        let index = search.order.conditions.findIndex(e => {
            return e.name === conditionName;
        });
        if (index !== -1) {
            search.order.conditions.splice(index, 1);
        }
    },
    globalSizeOnChange(search, pageSize) {
        if (pageSize !== '所有') {
            search.limit.enable = true;
            search.limit.conditions.pageStart = 1;
            search.limit.conditions.pageLength = pageSize;
        }
        else {
            search.limit.enable = false;
        }
    },
    globalSetFilterWithSearchForm(search, form) {
        search.filters.enable = form.length > 0;
        let conditions = form.map(v => {
            return { name: v.name, type: v.sql, value: v.value };
        });
        search.filters.conditions = conditions;
        search.limit.conditions.pageStart = 1;
    },
    deepClone(search) {
        return JSON.parse(JSON.stringify(search));
    },
    filterForm(arr) {
        // 前端过滤
        let formEd = [];
        arr.forEach(function (element) {
            switch (element.type) {
                case 'Input':
                    if (element.value.replace(/(^s*)|(s*$)/g, '').length !== 0) {
                        formEd.push(element);
                    }
                    break;
                case 'Checkbox':
                    formEd.push(element);
                    break;
                case 'Switch':
                    formEd.push(element);
                    break;
                case 'Daterange':
                    if (element.value.length > 0) {
                        let dateBegin = element.value[0];
                        let dateEnd = element.value[1];
                        if(dateBegin){
                            let aJson = new Date(dateBegin).toJSON();
                            if(aJson.length == 24 && aJson.indexOf('16:00:00') > -1){
                                dateBegin = this.formatSingleDate(dateBegin);
                                dateEnd = this.formatSingleDate(dateEnd);
                                // dateEnd = this.formatSingleDateAddOnyDay(dateEnd);
                            }
                        }
                        if (dateBegin && dateEnd) {
                            formEd.push(Object.assign({}, element, {
                                value: JSON.stringify([dateBegin, dateEnd])
                            }));
                        }
                    }
                    break;
                case 'DateTimeRange':
                    if (element.value.length > 0) {
                        let dateBegin = element.value[0];
                        let dateEnd = element.value[1];
                        if (dateBegin && dateEnd) {
                            formEd.push(Object.assign({}, element, {
                                value: JSON.stringify([dateBegin, dateEnd])
                            }));
                        }
                    }
                    break;
                case 'Date':
                    if (element.value.replace(/(^s*)|(s*$)/g, '').length !== 0) {
                        formEd.push(element);
                    }
                    break;
                case 'Select':
                    if (element.value != null && element.value !== undefined) {
                        if (Array.isArray(element.value)) {
                            if (element.value.length > 0) {
                                formEd.push(Object.assign({}, element, {
                                    value: JSON.stringify(element.value)
                                }));
                            }
                        }
                        else {
                            let arr = [];
                            arr.push(element.value);
                            formEd.push(Object.assign({}, element, {
                                value: JSON.stringify(arr)
                            }));
                        }
                    }
                    break;
                case 'RadioGroup':
                    if (element.value.replace(/(^s*)|(s*$)/g, '').length !== 0) {
                        formEd.push(element);
                    }
                    break;
                case 'CheckboxGroup':
                    if (element.value.length > 0) {
                        formEd.push(element);
                    }
                    break;
                case 'Cascader':
                    if (element.value.length >= 2) {
                        formEd.push(Object.assign({}, element, {
                            value: element.value[element.valueIndex]
                        }));
                    }
                    break;
                default:
                    break;
            }
        }, this);

        return formEd;
    }
};
